import { PlusOutlined } from '@ant-design/icons';
import { color, Common } from '@stockbit/ui';
import {
  ButtonDiscover,
  ContentWrapper,
  EmptyStateWrapper,
  Img,
} from './styled';

const { Text } = Common;

interface EmptyStateProps {
  description?: string;
  onDiscover?: () => void;
}

function EmptyState({
  description = 'Add your favourite investors and monitor your stocks',
  onDiscover,
}: EmptyStateProps) {
  return (
    <EmptyStateWrapper>
      <Img src="/images/empty_stream_box.png" alt="Empty stream" />
      <ContentWrapper>
        <Text family="bold" size="18px" mb="10px">
          Your Stream is Empty
        </Text>
        <Text size="16px" color={color.highgray} weight="bold" mb="32px">
          {description}
        </Text>
        {onDiscover ? (
          <ButtonDiscover onClick={onDiscover}>
            <PlusOutlined style={{ marginRight: '8px' }} />
            Discover
          </ButtonDiscover>
        ) : null}
      </ContentWrapper>
    </EmptyStateWrapper>
  );
}

export default EmptyState;
